module.exports = __webpack_public_path__ + "static/media/done.880cb3cf.svg";